angular.module( 'acme.view.application.users.detail', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.users.detail.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var usersDetail = {
        name: 'application.users.detail',
        url: '/:id/detail',
        views: {
          "subview-main": {
            controller: 'UsersDetailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/users/detail/detail.tpl.html'
          }
        },
        data: {
          pageTitle: 'User Details',
          /** Secure With Roles **/
          permissions: ['USERS_VIEW']
        }
      };

    $stateProvider
      .state(usersDetail);
});
